import { Pageheader } from './global-components/page-header';
import ReviewsGrid from './section-components/reviews-grid';
import bgImage from '../assets/img/banner/contact.webp';

const CustomerReviews = () => {
    return (
        <div>
            <Pageheader headertitle="Customer Reviews" bgImage={bgImage} />
            <ReviewsGrid />
        </div>
    );
};

export default CustomerReviews;
